/* JKP — mobile tab bar reveal + instant search suggestions. No dependencies. */
(function () {
  'use strict';

  /* ---------- Home: tab bar appears after the hero (first 100vh) ---------- */
  var tab = document.querySelector('[data-tabbar][data-home="true"]');
  if (tab) {
    var hero = document.querySelector('.trs-hero');
    var check = function () {
      var h = hero ? hero.offsetHeight : window.innerHeight;
      tab.classList.toggle('is-visible', window.scrollY >= h - 80);
    };
    check();
    window.addEventListener('scroll', check, { passive: true });
    window.addEventListener('resize', check);
  }

  /* ---------- Instant search ----------
     Whole catalogue (/products.json, ~50 KB gzipped) is fetched ONCE on first focus and cached in sessionStorage; every keystroke is then
     matched in memory (token-prefix, AND across words, scored) — no network round-trip per letter, so suggestions are instant at any
     connection speed. Collections come from a JSON blob rendered by Liquid (no request). If products.json is unavailable we fall back to
     Shopify's predictive-search endpoint with debounce + request cancellation. */
  var overlay = document.querySelector('[data-search-overlay]');
  var inputs = Array.prototype.slice.call(document.querySelectorAll('[data-suggest-input]'));
  if (!inputs.length) return;

  var collections = [];
  var cj = document.querySelector('[data-search-collections]');
  if (cj) { try { collections = JSON.parse(cj.textContent); } catch (e) {} }

  var index = null, loading = null, KEY = 'jkp-catalog-v1';
  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z0-9ऀ-ॿ ]+/g, ' ').replace(/\s+/g, ' ').trim(); }
  function build(list) {
    return list.map(function (p) {
      var v = p.variants && p.variants[0] || {};
      var title = norm(p.title);
      var rest = norm([p.product_type, p.vendor === 'My Store' ? '' : p.vendor, (p.tags || []).join(' ').replace(/(cat|colour|metal|sku)-/gi, '')].join(' '));
      return { t: p.title, h: p.handle, ty: p.product_type, pr: v.price, cp: v.compare_at_price, img: p.images && p.images[0] && p.images[0].src, tn: title, tw: title.split(' '), rest: rest, all: title + ' ' + rest, aw: (title + ' ' + rest).split(' ') };
    });
  }
  function load() {
    if (index) return Promise.resolve(index);
    if (loading) return loading;
    try { var c = sessionStorage.getItem(KEY); if (c) { index = build(JSON.parse(c)); return Promise.resolve(index); } } catch (e) {}
    loading = fetch('/products.json?limit=250', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (d) {
        var slim = d.products.map(function (p) { return { title: p.title, handle: p.handle, product_type: p.product_type, vendor: p.vendor, tags: p.tags, variants: [{ price: p.variants[0].price, compare_at_price: p.variants[0].compare_at_price }], images: p.images.slice(0, 1).map(function (i) { return { src: i.src }; }) }; });
        try { sessionStorage.setItem(KEY, JSON.stringify(slim)); } catch (e) {}
        index = build(slim); return index;
      })['catch'](function () { index = []; return index; });
    return loading;
  }

  function score(item, toks) {
    var s = 0;
    for (var i = 0; i < toks.length; i++) {
      var t = toks[i];
      // every typed word must START a word of the title / type / tags (AND), or (3+ letters) appear inside the title
      var pre = item.aw.some(function (w) { return w.indexOf(t) === 0; });
      if (!pre && !(t.length > 2 && item.tn.indexOf(t) !== -1)) return -1;
      if (item.tn.indexOf(t) === 0) s += 6;                             // title starts with it
      else if (item.tw.some(function (w) { return w.indexOf(t) === 0; })) s += 4;   // a title word starts with it
      else if (item.tn.indexOf(t) !== -1) s += 2;
      else s += 1;                                                      // matched type/tags only
    }
    return s - item.tn.length / 200;
  }
  function search(q) {
    var toks = norm(q).split(' ').filter(Boolean);
    if (!toks.length || !index) return { products: [], cols: [] };
    var res = [];
    for (var i = 0; i < index.length; i++) { var sc = score(index[i], toks); if (sc >= 0) res.push([sc, index[i]]); }
    res.sort(function (a, b) { return b[0] - a[0]; });
    var cols = collections.filter(function (c) { return toks.every(function (t) { return norm(c.t).indexOf(t) !== -1; }); }).slice(0, 4);
    return { products: res.slice(0, 8).map(function (r) { return r[1]; }), total: res.length, cols: cols };
  }

  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function hl(text, toks) {
    var out = esc(text);
    toks.forEach(function (t) { if (t.length) out = out.replace(new RegExp('(' + t.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + ')', 'ig'), '<mark>$1</mark>'); });
    return out;
  }
  function money(v) { var n = parseFloat(v); return isNaN(n) ? '' : 'Rs. ' + n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }

  function attach(input) {
    var box = document.getElementById(input.getAttribute('data-suggest-input'));
    if (!box) return;
    var active = -1, raf = 0, last = '';
    function items() { return box.querySelectorAll('a[data-sug]'); }
    function setActive(n) {
      var it = items(); if (!it.length) return;
      active = (n + it.length) % it.length;
      it.forEach(function (a, i) { a.classList.toggle('is-active', i === active); a.setAttribute('aria-selected', i === active ? 'true' : 'false'); });
      it[active].scrollIntoView({ block: 'nearest' });
    }
    function render() {
      var q = input.value;
      if (q === last) return; last = q; active = -1;
      var toks = norm(q).split(' ').filter(Boolean);
      if (!toks.length) { box.hidden = true; box.innerHTML = ''; return; }
      var r = search(q), html = '';
      if (r.cols.length) html += '<div class="jkp-sug-group"><p>Categories</p>' + r.cols.map(function (c) { return '<a data-sug href="' + esc(c.u) + '" class="jkp-sug-col"><span>' + hl(c.t, toks) + '</span><em>Browse all →</em></a>'; }).join('') + '</div>';
      if (r.products.length) {
        html += '<div class="jkp-sug-group"><p>Products</p>' + r.products.map(function (p) {
          return '<a data-sug href="/products/' + esc(p.h) + '" class="jkp-sug-prod">' + (p.img ? '<img src="' + esc(p.img) + (p.img.indexOf('?') === -1 ? '?width=120' : '&width=120') + '" alt="" width="52" height="52" decoding="async">' : '<span class="jkp-sug-noimg"></span>') +
            '<span class="jkp-sug-txt"><b>' + hl(p.t, toks) + '</b><i>' + esc(p.ty || '') + '</i></span><span class="jkp-sug-price">' + esc(money(p.pr)) + '</span></a>';
        }).join('') + '</div>';
        html += '<a data-sug class="jkp-sug-all" href="/search?type=product&q=' + encodeURIComponent(q) + '">See all ' + r.total + ' result' + (r.total === 1 ? '' : 's') + ' for “' + esc(q) + '”</a>';
      } else if (!r.cols.length) {
        html = index && index.length ? '<p class="jkp-sug-empty">No match for “' + esc(q) + '”. Try “ring”, “necklace” or “gold”.</p>' : '';
        if (!index || !index.length) predictive(q);
      }
      box.innerHTML = html; box.hidden = !html;
    }
    function predictive(q) {   // fallback only (products.json blocked)
      if (predictive.ac) predictive.ac.abort();
      var ac = predictive.ac = window.AbortController ? new AbortController() : null;
      fetch('/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', ac ? { signal: ac.signal } : {})
        .then(function (r) { return r.json(); }).then(function (d) {
          var ps = (d.resources && d.resources.results && d.resources.results.products) || [];
          if (input.value !== q) return;
          box.innerHTML = ps.map(function (p) { return '<a data-sug href="' + esc(p.url) + '" class="jkp-sug-prod"><span class="jkp-sug-txt"><b>' + esc(p.title) + '</b></span><span class="jkp-sug-price">' + esc(money(p.price)) + '</span></a>'; }).join('');
          box.hidden = !ps.length;
        })['catch'](function () {});
    }
    function schedule() { cancelAnimationFrame(raf); raf = requestAnimationFrame(function () { load().then(render); }); }
    input.addEventListener('focus', function () { load(); });
    input.addEventListener('input', schedule);
    input.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(active + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(active - 1); }
      else if (e.key === 'Enter' && active > -1) { e.preventDefault(); items()[active].click(); }
    });
    var form = input.form;
    if (form) form.addEventListener('submit', function () { try { sessionStorage.setItem('jkp-last-q', input.value); } catch (e) {} });
    if (input.value) { last = ''; load().then(render); }
  }
  inputs.forEach(attach);

  /* ---------- Search overlay open/close ---------- */
  if (overlay) {
    var inp = overlay.querySelector('[data-suggest-input]');
    var open = function () { overlay.hidden = false; document.body.classList.add('jkp-search-open'); document.body.style.overflow = 'hidden'; setTimeout(function () { inp.focus(); }, 30); load(); };
    var close = function () { overlay.hidden = true; document.body.classList.remove('jkp-search-open'); document.body.style.overflow = ''; };
    document.querySelectorAll('[data-search-open]').forEach(function (b) { b.addEventListener('click', function (e) { e.preventDefault(); open(); }); });
    overlay.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !overlay.hidden) close(); });
    overlay.addEventListener('click', function (e) { if (e.target === overlay) close(); });
  }
})();
